import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Service/Offend/scenario-based-penetration-test/ScenarioBasedPenetrationTest.tsx");
